export const NOT_EDITABLE_ROWS = {
  STUECKLISTE: [],
  STANDARD: [],
  UMWANDLUNGSHISTORIE: [],
  TITEL: [],
  TITELSUMME: [],
  ZWISCHENSUMME: [],
  TEXTZEILE: [],
};
